import { Recipe } from './model';

console.log("Env: ", process.env.NODE_ENV)
const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'http://dev.kevingnadinger.com';
export const fetchRecipes = (): Promise<any> => {
  const url = `${baseURL}/recipes`;
  return fetch(url)
}

export const fetchRecipe = (id: string): Promise<any> => {
  const url = `${baseURL}/recipes/${id}`
  return fetch(url)
};

export const updateRecipe = (recipe: Recipe): Promise<Response> => {
  const url = `${baseURL}/recipes/${<string>recipe.id}`
  const data = JSON.stringify({ recipe });
  return fetch(url, {
    method: 'PUT',
    headers: {
      "Content-Type": "application/json"
    },
    body: data
  })
};

export const createRecipe = (recipe: Recipe): Promise<Response> => {
  const url = `${baseURL}/recipes`
  const data = JSON.stringify({ recipe });
  return fetch(url, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: data
  })
};

export const pickRecipes = (ids: string[]): Promise<Response> => {
  const url = `${baseURL}/recipes/recipe_picker`;
  const data = JSON.stringify({ recipe_ids: ids });
  return fetch(url, {
    method: 'PATCH',
    headers: {
      "Content-Type": "application/json"
    },
    body: data
  })
}
